import React, { useContext, useEffect } from 'react';
import { PrimaryButton } from '@carvana/showroom-forms';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useRouter, ROUTES } from '../../../providers/router';
import CarCheckmarkIcon from '../../assets/images/CarCheckmarkIcon';
import { ModalContentWrapper, Text } from '../../../ASRCard.styles';
import { AsrAnalytics } from '../../../../../constants';

const ASRDisclaimer = ({ reportedConcerns, closeModal }: any) => {
  const { goToRoute } = useRouter();
  const { trackEvent } = useContext(AnalyticsContext);

  const fourteenDaysAgo = new Date((new Date()).getTime()-1209600000);
  const reportedConcernsWithin14Days = reportedConcerns.filter((asrIssue: any) => new Date(asrIssue.createdOn) >= fourteenDaysAgo);
  const issueCanBeCreated = reportedConcernsWithin14Days?.length < 3;

  useEffect(() => {
    if (issueCanBeCreated) {
      trackEvent(AsrAnalytics.COS_VIEWED_DISCLAIMER);
      datadogRum.addAction(AsrAnalytics.COS_VIEWED_DISCLAIMER);
    } else {
      trackEvent(AsrAnalytics.COS_VIEWED_LIMIT);
      datadogRum.addAction(AsrAnalytics.COS_VIEWED_LIMIT);
    }
  }, []);

  return (
    <ModalContentWrapper>
      <div style={{ textAlign: 'center' }}>
        <CarCheckmarkIcon />
      </div>
      {issueCanBeCreated ? (
        <>
          <Text>
            Every vehicle we sell undergoes a rigorous cosmetic inspection
            process. We hold ourselves to the highest quality standard, however,
            all of our vehicles were previously loved and have standard wear
            associated with normal vehicle usage.
          </Text>
          <Text>
            If your vehicle is not delivered in the condition displayed on our
            site, we want to know about it and make it right. You may submit up to
            three cosmetic concerns during your 7-Day Money Back Guarantee for
            review. Only concerns outside of Carvana standards & not visible on
            our site will be considered.
          </Text>
        </>
      ) : (
        <>
          <Text>
            You can only submit up to 3 cosmetic concerns within your 7-Day Money 
            Back Guarantee period. Unfortunately, you have reached this limit and 
            we are unable to accept additional submissions.
          </Text>
          <Text>
            Every vehicle we sell undergoes a rigorous cosmetic inspection
            process. We hold ourselves to the highest quality standard, however,
            all of our vehicles were previously loved and will have standard wear
            associated with normal vehicle usage.
          </Text>
        </>
      )}
      {issueCanBeCreated ? (
        <PrimaryButton
          onClick={() => {
            goToRoute(ROUTES.COSMETIC_IMAGES);
          }}
        >
          Continue
        </PrimaryButton>
      ) : (
        <PrimaryButton
          onClick={() => {
            closeModal();
          }}
        >
          Close
        </PrimaryButton>
      )}
    </ModalContentWrapper>
  );
};

export default ASRDisclaimer;
